type LoggedEvent = {
  readonly exception?: {
    readonly values?: readonly { readonly value?: string }[]
  }
}

type ParsedEvent = {
  readonly userAgent: string
  readonly message: string
}

type KnownNoise = {
  readonly name: string
  readonly matches: (event: ParsedEvent) => boolean
}

const parseEvent = (event: LoggedEvent, userAgent: string): ParsedEvent => ({
  userAgent,
  message: event?.exception?.values?.[0]?.value ?? ``
})

const facebookInAppBrowser: KnownNoise = {
  name: `FacebookInAppBrowser`,
  matches: event => event.userAgent.includes(`FBAN`)
}

const instagramInAppBrowser: KnownNoise = {
  name: `InstagramInAppBrowser`,
  matches: event => event.userAgent.includes(`Instagram`)
}

const headlessChromeBrowser: KnownNoise = {
  name: `HeadlessChromeBrowser`,
  matches: event => event.userAgent.includes(`HeadlessChrome`)
}

const gtmScriptLoadFailure: KnownNoise = {
  name: `GtmScriptLoadFailure`,
  matches: event =>
    event.message.includes(
      `Failed to load https://www.googletagmanager.com/gtag/js`
    )
}

const pageDataLoadFailure: KnownNoise = {
  name: `PageDataLoadFailure`,
  matches: event =>
    /We couldn't load "\/(.*?)\/page-data\/sq\/d\/(.*?)\.json"/.test(
      event.message
    )
}

const chunkLoadFailure: KnownNoise = {
  name: `ChunkLoadFailure`,
  matches: event => /Loading chunk [A-Za-z0-9]+ failed\./.test(event.message)
}

const testMockError: KnownNoise = {
  name: `TestMockError`,
  matches: event => event.message.includes(`should be blocked no.2`)
}

const knownNoiseCatalogue: readonly KnownNoise[] = [
  facebookInAppBrowser,
  instagramInAppBrowser,
  headlessChromeBrowser,
  gtmScriptLoadFailure,
  pageDataLoadFailure,
  chunkLoadFailure,
  testMockError
]

export const filterOutKnownNoise = (
  event: LoggedEvent,
  userAgent: string
): LoggedEvent | null => {
  const parsed = parseEvent(event, userAgent)
  return knownNoiseCatalogue.some(noise => noise.matches(parsed)) ? null : event
}
